import { createClient } from '@supabase/supabase-js'

// Debug de variables de entorno
console.log('=== INICIALIZACIÓN DE SUPABASE ===');
console.log('🌍 Ambiente:', process.env.NODE_ENV);
console.log('🔗 URL:', process.env.REACT_APP_SUPABASE_URL);
console.log('🔑 Key presente:', process.env.REACT_APP_SUPABASE_ANON_KEY ? 'true' : 'false');
console.log('🔐 Key length:', process.env.REACT_APP_SUPABASE_ANON_KEY?.length);
console.log('=================================');

const supabaseUrl = process.env.REACT_APP_SUPABASE_URL;
const supabaseAnonKey = process.env.REACT_APP_SUPABASE_ANON_KEY;

console.log('Configuración de Supabase:');
console.log('URL:', supabaseUrl);
console.log('Key:', supabaseAnonKey ? 'Presente' : 'Ausente');

if (!supabaseUrl || !supabaseAnonKey) {
  console.error('⚠️ Variables de entorno de Supabase no encontradas');
  throw new Error('Variables de entorno de Supabase no configuradas correctamente');
}

// Verificar configuración inicial
console.log('Configuración de Supabase:');
console.log('URL:', supabaseUrl);
console.log('Auth Config:', {
  autoRefreshToken: true,
  persistSession: true,
  detectSessionInUrl: true,
  storage: localStorage 
});

// Limpiar storage antiguo
localStorage.removeItem('supabase.auth.token');

// PRIMERO creamos el cliente
export const supabase = createClient(supabaseUrl, supabaseAnonKey, {
  db: {
    schema: 'public'
  },
  auth: {
    autoRefreshToken: true,
    persistSession: true,
    detectSessionInUrl: true,
    storage: window.localStorage
  }
});

// Verificar conexión inicial
supabase.auth.getSession().then(({ data: { session }, error }) => {
  if (error) {
    console.error('Error al verificar sesión:', error);
  } else {
    console.log('Sesión inicial:', session ? 'Presente' : 'Ausente');
    if (session) {
      console.log('Usuario:', session.user.email);
      console.log('ID de usuario:', session.user.id);
    }
  }
});

// Agregar listener para cambios de autenticación
supabase.auth.onAuthStateChange((event, session) => {
  console.log('Cambio de estado de autenticación:', event);
  console.log('Nueva sesión:', session ? 'Presente' : 'Ausente');
  if (session) {
    console.log('Usuario:', session.user.email);
    console.log('ID de usuario:', session.user.id);
  }
});

// Forzar actualización del esquema
supabase.from('lots').select('*').limit(0).then(() => {
  console.log('Esquema de Supabase actualizado');
}).catch(error => {
  console.error('Error al actualizar esquema:', error);
});